import { useEffect, useState } from 'react';
import { Button, Div, Group, Title, Panel, Spacing, Text } from '@vkontakte/vkui';
import { useAppContext } from '../../AppContext';
import PropTypes from 'prop-types';
import { PlatformPanelHeader } from './PlatformPanelHeader';

export const ErrorLoadComponent = ({error, description, buttonLabel, timeOut, onFetch}) => {
  const context = useAppContext();

  const [state, setState] = useState({
    seconds: 0,
    timeOut: timeOut || 0,
  });

  if (!description && error?.response?.data?.message) {
    description = error?.response?.data?.message;
  }

  useEffect(() => {
    context.popout(null);

    if (error?.response?.status === 429) {
      description = context.lang().getKey('errors', 'tooManyAttempts');
      state.timeOut = 30;
      state.seconds = 0;

      const interval = setInterval(() => {
        state.seconds = state.seconds + 1;
        setState({...state});

        if (state.seconds >= state.timeOut) {
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, []);

  return (<Panel>
    <PlatformPanelHeader
      text=""
      isShowBack={false}
    />
    <Group mode="plain">
      <Div className={'ErrorLoad'}>
        <Spacing size={'40vh'}/>
        <Text>
          {description || context.lang().getKey('errors', 'loadData')}
        </Text>
        {
          state.timeOut > 0 && (<Title>{state.timeOut - state.seconds}</Title>)
        }
        <Spacing />
        <Button
          onClick={() => onFetch()}
          disabled={state.timeOut > 0 && state.timeOut > state.seconds}
          loading={state.timeOut > 0 && state.timeOut > state.seconds}
        >
          {buttonLabel || context.lang().getKey('app', 'reload_button_label')}
        </Button>
      </Div>
    </Group>
  </Panel>);
}

ErrorLoadComponent.propTypes = {
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  onFetch: PropTypes.func.isRequired,
};